<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
        <i-card-top
          class="d-flex"
          headerTitle
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
        >
          <template v-slot:body>
            <v-layout overflow-auto></v-layout>
          </template>
        </i-card-top>
      </v-col>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
        <i-card-vertical headerTitle="공사관리" device="web">
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" lg="12" class="pa-0">
                  <DxDataGrid
                    id="constructDataGrid"
                    class="layout-col-height00"
                    :ref="dxDataGridRef"
                    :data-source="gridMain"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    @row-updating="onRowUpdating"
                    @editing-start="onEditingStart"
                    @editor-preparing="onEditorPreparing"
                    key-expr="uniqueKey"
                  >
                    <DxEditing
                      mode="batch"
                      :allow-updating="true"
                      :select-text-on-edit-start="true"
                    />

                    <DxSelection
                      select-all-mode="allPages"
                      show-check-boxes-mode="always"
                      mode="multiple"
                    />

                    <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
                    <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>
                    <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn>
                    <DxColumn data-field="docNo" data-type="string" :visible="false"></DxColumn>

                    <DxColumn
                      data-field="save"
                      data-type="string"
                      width="160px"
                      alignment="center"
                      caption
                      :allow-editing="false"
                      cell-template="actionTemplete"
                    ></DxColumn>
                    <template #actionTemplete="{ data: cellInfo }">
                      <div>
                        <v-btn
                          color="btn_sub"
                          elevation="0"
                          dark
                          small
                          @click="btnDetail(cellInfo)"
                          class="mr-2 rounded"
                        >상세보기</v-btn>
                      </div>
                    </template>

                    <DxColumn
                      data-field="constructNm"
                      caption="공사명"
                      data-type="string"
                      alignment="left"
                    />
                    <DxColumn
                      data-field="constructTerm"
                      caption="공사 기간"
                      data-type="string"
                      alignment="center"
                      :allow-editing="false"
                    />
                    <DxColumn
                      data-field="minorNm"
                      caption="계약 승인"
                      width="150px"
                      data-type="string"
                      alignment="center"
                      cell-template="approvalStatusTemplate"
                      :allow-editing="false"
                    />
                    <template #approvalStatusTemplate="{ data: cellInfo }">
                      <div
                        v-if="cellInfo.data.approvalStatus == 'N'"
                        style="color:red;"
                      >{{ cellInfo.displayValue }}</div>
                      <div
                        v-else-if="cellInfo.data.approvalStatus == 'A'"
                        style="color:blue;"
                      >{{ cellInfo.displayValue }}</div>
                      <div
                        v-else-if="cellInfo.data.approvalStatus == 'R'"
                      >{{ cellInfo.displayValue }}</div>
                    </template>

                    <DxColumn
                      data-field="constructLocation"
                      caption="소재지"
                      data-type="string"
                      alignment="left"
                    />
                  </DxDataGrid>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getConstructManage, saveConstructManage } from '@/api/sojunganManagement/constructManage'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'constructDataGrid',
  components: {},
  data() {
    return {
      dxDataGridRef: 'constructDataGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', // 추가
        'btnSave' //저장
      ],
      allMode: 'allPages'
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    if (this.$route.params.data) {
      let params = this.$route.params.data
      if (params.flag) {
        this.btnSearch(true)
      }
    }
  },

  methods: {
    //------------------------------------------
    //  공사관리 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      this.openLoading('searching')

      try {
        let params = {
          clntId: this.getClntId()
        }

        const response = await getConstructManage(params, isNotify)
        if (response.success) {
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.gridMain = []
          this.gridMain = response.list
          this.gridMain = response.list.map(item => {
            item.uniqueKey = `${item.clntId}${item.compId}${item.writeDt}${item.docNo}`
            item.constructTerm = `${item.constructDtS.slice(0, 4)}.${item.constructDtS.slice(4, 6)}.${item.constructDtS.slice(
              6,
              8
            )} ~ ${item.constructDtE.slice(0, 4)}.${item.constructDtE.slice(4, 6)}.${item.constructDtE.slice(6, 8)}`
            return item
          })
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        }
      } catch (error) {
        console.error('getConstructManage error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  공사관리 추가
    //------------------------------------------
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', { value: true })
      Object.defineProperty(data, 'clntId', { value: this.getClntId() })
      const toRouter = {
        name: 'ConstructManageDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    //------------------------------------------
    //  공사관리 저장
    //------------------------------------------
    async btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }

          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              for (const item of selectedRows) {
                if (item.constructNm == '' || item.constructNm == null) {
                  this.vToastify(this.$t('공사명이 입력되지 않았습니다.'), 'info')
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  return
                }
              }
              //저장 api
              this.openLoading('saving')
              try {
                const response = await saveConstructManage(selectedRows, true)
                if (response.success) {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.btnSearch(false)
                }
              } catch (error) {
                console.error('saveConstructManage error catch >> ', error)
              } finally {
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  공사관리 상세페이지 이동
    //------------------------------------------
    async btnDetail(cellInfo) {
      cellInfo.data.__created__ = false
      const toRouter = {
        name: 'ConstructManageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {},
    //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
  }
}
</script>